export const setBannerCookie = () => {
  const today = new Date(Date.now()).toISOString();
  const oneYear = 60 * 60 * 24 * 365;
  document.cookie =
    "OptanonAlertBoxClosed=" + today + "; max-age=" + oneYear + "; path=/";
};
